import { useTranslation } from "react-i18next";

export const ContentLoader = () => {
  const { t } = useTranslation();
  return (
    <section className="section">
      <div className="container has-text-centered">
        <div className="content-loader" role="status" aria-label={t("error.loadingSession")} />
      </div>
    </section>
  );
};
